<template>
  <component :is='layout'>
    <router-view/>
  </component>
  <Footer/>
  <notifications position="bottom right" classes="my-notification"/>
</template>

<script>
import BaseLayout from '@/layouts/BaseLayout.vue'
import MainLayout from '@/layouts/MainLayout.vue';
import AdminLayout from '@/layouts/AdminLayout.vue';
import Footer from '@/components/app/Footer.vue';
export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || 'base') + '-layout';
    },

  },
  components: {
    BaseLayout, MainLayout, AdminLayout, Footer,
  }
}
</script>


<style lang="less">
  //@import '~materialize-css/dist/css/materialize.min.css';
  @import '@/assets/css/lk.css';
  @import '@/assets/css/lk_add.css';
  @import 'vue3-easy-data-table/dist/style.css';
  @import 'maz-ui/css/main.css';
  //@import 'assets/css/loading.css';
  .my-notification {

    margin: 0 5px 5px;
    padding: 10px;
    font-size: 14px;
    color: #ffffff;


    background: #00C24590;
    border-left: 5px solid #187fe7;
    border-radius: 20px;


    &.success {
      background: #00C24590;
      border-left-color: #42a85f;
    }

    &.warn {
      background: #f7960590;
      border-left-color: #f48a06;
    }

    &.error {
      background: #E1336E90;
      border-left-color: #b82e24;
    }
  }

</style>